/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const appointmentStatsAsOfRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentStatsBucketsItemCountOneMin = 0
export const appointmentStatsBucketsItemCountOneMax = 9007199254740991

export const appointmentStatsBucketsItemStartRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const appointmentStatsFromRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentStatsSourcesItemCountMin = -9007199254740991
export const appointmentStatsSourcesItemCountMax = 9007199254740991

export const appointmentStatsSourcesItemSourceOneRegExp = new RegExp('^[a-z0-9_-]{1,40}$')
export const appointmentStatsToRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentStatsTotalMin = 0
export const appointmentStatsTotalMax = 9007199254740991

export const AppointmentStats = zod.object({
  asOf: zod.iso.datetime({ offset: true }).regex(appointmentStatsAsOfRegExp),
  bucketUnit: zod.enum(['day', 'week']),
  buckets: zod.array(
    zod.object({
      count: zod.union([
        zod.int().min(appointmentStatsBucketsItemCountOneMin).max(appointmentStatsBucketsItemCountOneMax),
        zod.null(),
      ]),
      start: zod.string().regex(appointmentStatsBucketsItemStartRegExp),
    }),
  ),
  from: zod.iso.datetime({ offset: true }).regex(appointmentStatsFromRegExp),
  period: zod.enum(['week', 'month', '3m']),
  sources: zod.array(
    zod.object({
      count: zod.int().min(appointmentStatsSourcesItemCountMin).max(appointmentStatsSourcesItemCountMax),
      saved: zod.boolean(),
      source: zod.union([zod.string().regex(appointmentStatsSourcesItemSourceOneRegExp), zod.null()]),
    }),
  ),
  to: zod.iso.datetime({ offset: true }).regex(appointmentStatsToRegExp),
  total: zod.int().min(appointmentStatsTotalMin).max(appointmentStatsTotalMax),
})

export type AppointmentStats = zod.input<typeof AppointmentStats>
export type AppointmentStatsOutput = zod.output<typeof AppointmentStats>
